import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UtilityService } from '../../services';

@Component({
  selector: 'app-date-field',
  templateUrl: './global-date.component.html',
})
export class GlobalDateComponent {

  @Input() label = 'Date';
  @Input() errMsg?: string;
  @Input() hint?: string;
  @Input() placeholder?: string;
  @Input() control: FormControl;
  @Input() tooltip;
  @Input() minDate;
  @Input() maxDate;

  constructor(private util: UtilityService) { }

  isRequired() {
    return this.util.isRequired(this.control);
  }

}
